import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React from 'react'
import c from '../classnames.scss'
import {Form} from '../form/container'
import s from './buyer-details.scss'
import {BuyerDetailsProps} from './interfaces'

export const BuyerDetails = ({
  editing,
  details,
  initialValues,
  disabledFields,
  assignedTicketsEnabled,
  onSubmit,
}: BuyerDetailsProps) =>
  editing ? (
    <div className={s.container}>
      <Form
        initialValues={initialValues}
        disabledFields={disabledFields}
        hideAdditionalFields={assignedTicketsEnabled}
        onFormSubmit={onSubmit}
      />
    </div>
  ) : (
    <div
      data-hook={DH.CHECKOUT_BUYER_DETAILS}
      className={classNames(s.details, c.formLabelsFont, c.formLabelsColor, s.opaque)}
    >
      <div>
        {details.firstName} {details.lastName}
      </div>
      <div>{details.email}</div>
    </div>
  )
